module.exports = __webpack_public_path__ + "img/house-chimney-crack.e76e7cdc.svg";